import { useState } from 'react';
import './App.css';
import Login from './Pages/Login/Login.jsx'
import SignUp from "./Pages/SignUp/SignUp.jsx"
import { app} from './credenciales'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import './Pages/Login/Login.module.css'

const auth = getAuth(app)

function App() {
  
  const [usuario, setUsuario] = useState(null)

  onAuthStateChanged(auth, (usuarioFirabase) =>{
    if(usuarioFirabase){
      setUsuario(usuarioFirabase)
    }
    else{
      setUsuario(null)
    }
  }) 

  return (
    <div>
      {usuario ? <Login/> : <SignUp/>}
    </div>
  );
}

export default App;
